<!-- <div class="w-100" style="position: absolute; top: 30%;"> -->
<div class="main">
    <div class="container">
        <div class="d-flex justify-content-center" style="height: 50vh">
            <div class="d-flex flex-column align-items-center justify-content-center">
                <a class="navbar-brand m-3" [href]="Constant.url_home"><img
                        [src]="'logo/fmarket-blue.png' | image" alt="fmarket"
                        width="128"/></a>
                <p class="text-center">
                    Ứng dụng đầu tư quỹ mở hàng đầu Việt Nam,
                    được Ủy ban Chứng khoán Nhà nước cấp phép ngày 02/04/2018.
                </p>
                <button class="btn btn__more" (click)="open()"
                    style="background-color: #0368fe; color: white;max-width: 300px;">
                    Tải ứng dụng
                </button>
                <a class="mt-2" [href]="Constant.url_home">{{'Về trang chủ'}}</a>
            </div>
        </div>
    </div>
</div>
<fmarket-footer></fmarket-footer>